module.exports = __webpack_public_path__ + "static/media/sub_back.57cfc2bc.png";